@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.cost-review-summary {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 13px;
  background-color: @cost-review-item--summary--background-color;
  padding: @space-8;
  gap: @space-8;
}

.ship-date {
  display: flex;
  align-items: center;
  font-weight: @bold;
}

.ship-date-input {
  width: 160px;
  line-height: 0;
  margin-top: 5px;
  margin-left: 5px;
}

.cost-summary-section {
  display: flex;
  flex-direction: column;
  gap: @space-8;
}

.line-item {
  display: flex;
  justify-content: space-between;
}

.line-item-with-icon {
  display: flex;
  gap: 5px;
  align-items: top;
}

.info-icon {
  height: 13px;
  width: 13px;
  color: var(--grey-600);
}

.total {
  font-weight: @bold;
  padding-top: @space-8;
  border-top: 1px solid @cost-review-item--summary--border-color;
}

.hide-ship-date {
  display: none;
}

.tooltip-icon {
  width: @space-16;
  color: var(--default--icon-button--fill-color--1);
  cursor: pointer;
}

.tooltip-wrapper {
  margin-right: @space-8;
  position: relative;
  top: 2px;
}
